import { ApolloError } from "@apollo/client";
import { Colors } from "@snapchat/snap-design-system";
import { ErrorIcon } from "@snapchat/snap-design-system-icons";
import { type FC, type ReactNode, useMemo } from "react";
import { orgStatErrors } from "../../errors/errors";
import { ChartNotice } from "./ChartNotice";

export const ApiErrorNotice: FC<{ error?: ApolloError; children: ReactNode | ReactNode[] }> = ({ error, children }) => {
    const message = useMemo(() => {
        if (!error) return "";

        return orgStatErrors.find(({ code }) => error.message.includes(code))?.message ?? "Please refresh the page.";
    }, [error]);

    if (!error) {
        return <>{children}</>;
    }

    return <ChartNotice icon={<ErrorIcon size={24} fill={Colors.Red.V200} />} title="API Error" message={message} />;
};
